export default __webpack_public_path__ + "static/media/logo-paperboy.06c30007.svg";